import { useEffect, useState } from 'react';

import { AboutPayload } from '../types';
import { fetchAbout } from '../services/aboutService';

export const useAbout = () => {
  const [about, setAbout] = useState<AboutPayload | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadAbout = async () => {
      try {
        const aboutData = await fetchAbout();
        if (isMounted) {
          setAbout(aboutData);
        }
      } catch (error) {
        console.error('Failed to load about content', error);
      }
    };

    loadAbout();

    return () => {
      isMounted = false;
    };
  }, []);

  return { about };
};
